import { CampaignCreationStoreState } from 'modules/campaign-creation/stores/CampaignCreationStore';
import { CampaignType } from 'generated-graphql/types';

type RecipientOption = {
  label: string;
  value: string;
};

type ChooseRecipientsConfig = {
  label: string;
  options: RecipientOption[];
};

export const getChooseRecipientsConfig = (
  state: CampaignCreationStoreState | null,
  isListsAvailable: boolean
): ChooseRecipientsConfig => {
  const isIntegrated = !!state?.ATSJobDescriptionState?.selectedJob;
  const isAboutJob = state?.campaignType !== CampaignType.EngagementOutreach;

  // Standalone
  if (!isIntegrated) {
    // About a job OR About something else (same for standalone)
    return {
      label: 'Are you contacting candidates from a Popp analysis?',
      options: [
        { label: 'Yes', value: 'specific' },
        { label: 'No', value: 'imported' }
      ]
    };
  }

  // Integrated
  if (isAboutJob) {
    // About a job
    const options = [
      { label: 'Everyone who applies to this job', value: 'everyone' },
      { label: 'Specific applicants in a Popp analysis', value: 'specific' },
      { label: 'Candidates in a list or group', value: 'imported' }
    ];

    // Filter out imported option if lists are not available
    return {
      label: 'Who do you want to send this to?',
      options: isListsAvailable
        ? options
        : options.filter((opt) => opt.value !== 'imported')
    };
  }

  // About something else
  return {
    label: 'Are you contacting candidates from a Popp analysis?',
    options: [
      { label: 'Yes', value: 'specific' },
      { label: 'No', value: 'imported' }
    ]
  };
};
